import { useAuthorizedQuery } from "../api/authorized-query";
import { seedgreenAPI } from "../api/axios";
import { STALE_TIME_MEDIUM } from "../query/query.constants";
import { useQuery } from "@tanstack/vue-query";
const NOTE_OBSERVATION_STALE_TIME = STALE_TIME_MEDIUM;
export function useNoteObservationCategories() {
    const query = useQuery({
        enabled: useAuthorizedQuery(),
        queryKey: ["noteObservationCategories"],
        queryFn: async () => {
            const response = await seedgreenAPI.get("v2/note/observation/category");
            return response.data;
        },
        staleTime: NOTE_OBSERVATION_STALE_TIME,
    });
    return {
        categories: query.data,
        ...query,
    };
}
